import { createMuiTheme } from '@material-ui/core';
import * as palette from '@material-ui/core/colors';
import cookie from 'react-cookies';

const multiplier = .3
const shadows = [
    "none",
    "0px 1px 3px 0px rgba(0, 0, 0, 0.2),0px 1px 1px 0px rgba(0, 0, 0, 0.14),0px 2px 1px -1px rgba(0, 0, 0, 0.12)",
    "0px 1px 5px 0px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 3px 1px -2px rgba(0, 0, 0, 0.12)",
    "0px 1px 8px 0px rgba(0, 0, 0, 0.2),0px 3px 4px 0px rgba(0, 0, 0, 0.14),0px 3px 3px -2px rgba(0, 0, 0, 0.12)",
    "0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
    "0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 5px 8px 0px rgba(0, 0, 0, 0.14),0px 1px 14px 0px rgba(0, 0, 0, 0.12)",
    "0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px 0px rgba(0, 0, 0, 0.14),0px 1px 18px 0px rgba(0, 0, 0, 0.12)",
    "0px 4px 5px -2px rgba(0, 0, 0, 0.2),0px 7px 10px 1px rgba(0, 0, 0, 0.14),0px 2px 16px 1px rgba(0, 0, 0, 0.12)",
    "0px 5px 5px -3px rgba(0, 0, 0, 0.2),0px 8px 10px 1px rgba(0, 0, 0, 0.14),0px 3px 14px 2px rgba(0, 0, 0, 0.12)",
    "0px 5px 6px -3px rgba(0, 0, 0, 0.2),0px 9px 12px 1px rgba(0, 0, 0, 0.14),0px 3px 16px 2px rgba(0, 0, 0, 0.12)",
    "0px 6px 6px -3px rgba(0, 0, 0, 0.2),0px 10px 14px 1px rgba(0, 0, 0, 0.14),0px 4px 18px 3px rgba(0, 0, 0, 0.12)",
    "0px 6px 7px -4px rgba(0, 0, 0, 0.2),0px 11px 15px 1px rgba(0, 0, 0, 0.14),0px 4px 20px 3px rgba(0, 0, 0, 0.12)",
    "0px 7px 8px -4px rgba(0, 0, 0, 0.2),0px 12px 17px 2px rgba(0, 0, 0, 0.14),0px 5px 22px 4px rgba(0, 0, 0, 0.12)",
    "0px 7px 8px -4px rgba(0, 0, 0, 0.2),0px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px 4px rgba(0, 0, 0, 0.12)",
    "0px 7px 9px -4px rgba(0, 0, 0, 0.2),0px 14px 21px 2px rgba(0, 0, 0, 0.14),0px 5px 26px 4px rgba(0, 0, 0, 0.12)",
    "0px 8px 9px -5px rgba(0, 0, 0, 0.2),0px 15px 22px 2px rgba(0, 0, 0, 0.14),0px 6px 28px 5px rgba(0, 0, 0, 0.12)",
    "0px 8px 10px -5px rgba(0, 0, 0, 0.2),0px 16px 24px 2px rgba(0, 0, 0, 0.14),0px 6px 30px 5px rgba(0, 0, 0, 0.12)",
    "0px 8px 11px -5px rgba(0, 0, 0, 0.2),0px 17px 26px 2px rgba(0, 0, 0, 0.14),0px 6px 32px 5px rgba(0, 0, 0, 0.12)",
    "0px 9px 11px -5px rgba(0, 0, 0, 0.2),0px 18px 28px 2px rgba(0, 0, 0, 0.14),0px 7px 34px 6px rgba(0, 0, 0, 0.12)",
    "0px 9px 12px -6px rgba(0, 0, 0, 0.2),0px 19px 29px 2px rgba(0, 0, 0, 0.14),0px 7px 36px 6px rgba(0, 0, 0, 0.12)",
    "0px 10px 13px -6px rgba(0, 0, 0, 0.2),0px 20px 31px 3px rgba(0, 0, 0, 0.14),0px 8px 38px 7px rgba(0, 0, 0, 0.12)",
    "0px 10px 13px -6px rgba(0, 0, 0, 0.2),0px 21px 33px 3px rgba(0, 0, 0, 0.14),0px 8px 40px 7px rgba(0, 0, 0, 0.12)",
    "0px 10px 14px -6px rgba(0, 0, 0, 0.2),0px 22px 35px 3px rgba(0, 0, 0, 0.14),0px 8px 42px 7px rgba(0, 0, 0, 0.12)",
    "0px 11px 14px -7px rgba(0, 0, 0, 0.2),0px 23px 36px 3px rgba(0, 0, 0, 0.14),0px 9px 44px 8px rgba(0, 0, 0, 0.12)",
    "0px 11px 15px -7px rgba(0, 0, 0, 0.2),0px 24px 38px 3px rgba(0, 0, 0, 0.14),0px 9px 46px 8px rgba(0, 0, 0, 0.12)",
].map(s => s.replace("0.2", 0.2 * multiplier).replace("0.14", 0.14 * multiplier).replace("0.12", 0.12 * multiplier))

export const getTheme = (doChangeTheme) => {

    let primary = undefined
    let secondary = undefined

    try {
        primary = cookie.load('i-theme-primary')
        secondary = cookie.load('i-theme-secondary')
    } catch (err) {
        console.log('Can\'t load existing theme: ', err)
    }

    let theme = undefined

    try {
        theme = createMuiTheme({
            doChangeTheme: theme => doChangeTheme(theme),
            palette: {
                primary: primary || {
                    main: palette.indigo['700'],
                    dark: palette.indigo['900'],
                    light: palette.indigo['300'],
                    contrastText: '#FFFFFF'
                },
                secondary: secondary || {
                    main: palette.indigo['A200'],
                    dark: palette.indigo['A100'],
                    light: palette.indigo['A400'],
                    contrastText: '#FFFFFF'
                },

                white: 'rgba(255, 255, 255, 1)',
                whiteSecondary: 'rgba(255, 255, 255, .83)',
                whiteDisabled: 'rgba(255, 255, 255, .6)',
                black: 'rgba(0, 0, 0, 1)',
                blackSecondary: 'rgba(0, 0, 0, .83)',
                blackDisabled: 'rgba(0, 0, 0, .6)',

                ...palette
            },
            transitions: {
                easing: {
                    material: 'cubic-bezier(.8, .2, .2, .8)'
                }
            },
            shape: {
                borderRadius: 8
            },
            shadows
        })
    } catch (err) {
        theme = createMuiTheme({
            doChangeTheme: theme => doChangeTheme(theme),
            palette: {
                primary: {
                    main: '#184055',
                    dark: '#113244',
                    light: '#5D7988',
                    contrastText: '#FFFFFF'
                },
                secondary: {
                    main: palette.amber['600'],
                    dark: palette.amber['800'],
                    light: palette.amber['400'],
                    contrastText: '#FFFFFF'
                },

                white: 'rgba(255, 255, 255, 1)',
                whiteSecondary: 'rgba(255, 255, 255, .83)',
                whiteDisabled: 'rgba(255, 255, 255, .6)',
                black: 'rgba(0, 0, 0, 1)',
                blackSecondary: 'rgba(0, 0, 0, .83)',
                blackDisabled: 'rgba(0, 0, 0, .6)',

                ...palette
            },
            transitions: {
                easing: {
                    material: 'cubic-bezier(.8, .2, .2, .8)'
                }
            },
            overrides: {
                MuiPaper: {
                    rounded: {
                        borderRadius: 12
                    }
                }
            },
            shadows
        })
    }

    return theme
}


// WEBPACK FOOTER //
// ./src/components/theme/Theme.js